import React, { ReactElement } from 'react';
import { MenuItemContainer, MenuItemTitle, MenuLabel, MenuItemLiContainer } from './MenuItem.styled';
import { ComponentProps } from './MenuItem.types';

const MenuItem: React.FC<ComponentProps> = ({
  icon,
  statusIcon,
  title,
  isActive = false,
  isDisabled = false,
  ...props
}): ReactElement<ComponentProps> => {
  return (
    <MenuItemLiContainer>
      <MenuItemContainer isActive={isActive} isDisabled={isDisabled} {...props}>
        <MenuLabel>
          {icon}
          <MenuItemTitle>{title}</MenuItemTitle>
        </MenuLabel>
        {statusIcon}
      </MenuItemContainer>
    </MenuItemLiContainer>
  );
};

export default MenuItem;
